/* hs-eslint ignored failing-rules */

/* eslint-disable no-prototype-builtins */
'use es6';

import { getLanguages, CONSENT_FIELDS } from 'SharedLegalStrings/consent/constants';
import { getDefaultConsentTextWithCompanyName } from 'SharedLegalStrings/consent/getDefaultConsentText';

function transformHubSettingsArray(hubSettings) {
  const settings = {};
  hubSettings.forEach(setting => settings[setting.key] = setting.value);
  return settings;
}

export default (({
  communicationConsentSettings,
  companyName
}) => {
  const settings = transformHubSettingsArray(communicationConsentSettings);
  const consentCopy = {};
  getLanguages().forEach(lang => {
    consentCopy[lang] = {};
    CONSENT_FIELDS.forEach(field => {
      const settingsKey = `${field}:${lang}`;

      if (settings.hasOwnProperty(settingsKey)) {
        consentCopy[lang][field] = settings[settingsKey];
        delete settings[settingsKey];
      } else {
        consentCopy[lang][field] = getDefaultConsentTextWithCompanyName(field, {
          locale: lang,
          companyName
        });
      }
    });
  });
  settings.consentCopy = consentCopy;
  return settings;
});